<template>
    <div>
        <div id="container-button" v-if="direction != null" class="w-fit hover:cursor-pointer text-button-desktop max-md:text-button-mobile">
            <RouterLink id="button" :to="props.direction" :class="type" class="rounded-smoth px-third py-min">
                <span>{{ props.textButton }}</span>
            </RouterLink>
        </div>

        <div v-if="direction == null" id="container-button" class="w-fit hover:cursor-pointer text-button-desktop max-md:text-button-mobile">
            <div id="button" :class="type" class="rounded-smoth px-third py-min w-fit">
                <span class="text-center flex w-full">{{ props.textButton }}</span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { RouterLink } from 'vue-router';

const props = defineProps([
    'textButton',
    'type',
    'direction'
])
</script>